class Configuration {
    static $inject = ['source', 'releaseVersion'];
    constructor(source, releaseVersion) {
        this.source = source;
        this.releaseVersion = releaseVersion;
    }

    get uncachedScriptURI() { return this.source + '/main.js?nocache=' + this.releaseVersion; }
    get uncachedSettingsURI() { return this.source + '/settings.json?nocache=' + this.releaseVersion; }
}

export class MFEsConfigs {
    static $inject = ['mfeSettings', 'settings'];
    constructor(mfeSettings, settings) {
        for(const mfe in mfeSettings) this[mfe] = new Configuration(mfeSettings[mfe].source, mfeSettings[mfe].releaseVersion);

        this.fallback = settings;

        return new Proxy(this, {
            get(target, name) {
                try {

                    if (name in target) return target[name];
                    else return {
                        uncachedScriptURI: target.fallback[name].microFrontendSource + target.fallback[name].mainScriptPath,
                        uncachedSettingsURI: target.fallback[name].microFrontendSource + target.fallback[name].settingsPath,
                    };
                } catch (error) {
                    return [];
                }
            },
        });
    }
}